// const HOST = "http://localhost:9292/api/private/v1/proposals_public";

const HOST = "https://api.propmage.com/api/private/v1/proposals_public";

export { HOST };
